import { combineReducers } from 'redux';

import del, * as fromDel from './del';
import update, * as fromUpdate from './update';
import fetch, * as fromFetch from './fetch';
import list, * as fromList from './list';
import select, * as fromSelect from './select';

export default combineReducers({
  fetch,
  update,
  del,
  list,
  select,
});

export const areFetching = (state) => fromFetch.areFetching(state.fetch);

export const getSegments = (state) => fromFetch.getSegments(state.fetch);

export const isUpdating = (state) => fromUpdate.isUpdating(state.update);

export const getUpdating = (state) => fromUpdate.getUpdating(state.update);

export const getUpdatingId = (state) => fromUpdate.getUpdatingId(state.update);

export const isDeleting = (state) => fromDel.isDeleting(state.del);

export const getFilterValue = (state) => fromList.getFilterValue(state.list);

export const getSelected = (state) => fromSelect.getSelected(state.select);

export const getSideListContainerWidth = (state) => fromList.getSideListContainerWidth(state.list);

export const isSegmentExists = (state, segment) =>
  getSegments(state).find(({ id }) => id === segment.id);
